export default __webpack_public_path__ + "static/media/home-active.201de3d2.svg";